<div class="message-wrapper">
  <div class="full-message-container" *ngIf="shouldDisplayMessage || message.content.length">
    <app-polaris-icon class="copilot-avatar"></app-polaris-icon>
    <div class="copilot-message-container" [class.expended]="!shouldDisplayThink">
      <div class="copilot-message-title">
        {{ polarisName }}
      </div>
      <div class="copilot-message-content">
        <app-progress-bar *ngIf="!message.content.length && !message.error" [startTimestamp]="message.timestamp"></app-progress-bar>
        <app-markdown *ngIf="shouldDisplayThink && !message.content.length; else answerSegments" [rawMarkdown]="'Thinking...'" [trusted]="true"></app-markdown>
        <ng-template #answerSegments>
          <ng-container *ngFor="let segment of getSegments(); trackBy: trackBySegmentIndex">
            <app-markdown class="answer-segment" [rawMarkdown]="segment.text" [trusted]="true"></app-markdown>
            <app-anchor-chip
              *ngIf="segment.group"
              [groupId]="segment.group.id"
              [creativeCount]="segment.group.cards.length"
              [brandLogos]="segment.brandLogos"
              [loading]="segment.loading"
              [isActive]="!segment.loading && segment.group.id === libraryState().activeGroupId">
            </app-anchor-chip>
          </ng-container>
        </ng-template>
        <div class="try-again-container" *ngIf="message.error">
          <app-button [text]="'Try again'" [class]="'primary'" (click)="tryAgain()">Try again</app-button>
        </div>
      </div>
    </div>
    <app-copilot-creatives-message *ngIf="shouldShowCreativesFallback()" [creativesURLs]="message.creativesURLs"></app-copilot-creatives-message>
    <app-copilot-insights-message [insights]="message.insights"></app-copilot-insights-message>
    <app-copilot-web-insights-message [webInsights]="message.webInsights"></app-copilot-web-insights-message>
    <app-copilot-citations-message [citations]="message.citations"></app-copilot-citations-message>
    <ng-container *ngFor="let graph of message.graphs">
      <app-copilot-graphs-message [data]="graph"></app-copilot-graphs-message>
    </ng-container>
    <app-copilot-followup-questions-message [followUpQuestions]="message.followUpQuestions | trimSurroundingQuotes" [sendMessage]="sendMessage" [disabled]="!shouldDisplayRetryButton" (onError)="chatNotFound.emit()"></app-copilot-followup-questions-message>
  </div>
  <div class="response-action-buttons-container">
    <app-response-action-buttons
      *ngIf="message.content.length"
      [isCopySucceeded]="isCopySucceeded"
      [shareable]="shareable"
      [shouldDisplayRetryButton]="shouldDisplayRetryButton"
      [userResponse]="message.userResponse"
      (copy)="onCopy()" (share)="onShare()" (goodResponse)="onGoodResponse()" (badResponse)="onBadResponse()" (retry)="onRetry()"
    ></app-response-action-buttons>
  </div>
</div>
